<template>
  <label :class="`${isDisabled ? 'checkbox is-disabled' : 'checkbox' }`">
    <template v-if="name !== ''">
      <input type="radio" :name="name" @change="onSelect" :checked="isChecked" />
    </template>
    <template v-else>
      <input type="checkbox" :name="name" @change="onSelect" :checked="isChecked" />
    </template>
    <icon name="check" class="checkbox__icon" height="12" width="12"></icon>
  </label>
</template>

<script>
export default {
  name: 'form-input',
  props: [
    'type',
    'name',
    'id',
    'onSelect',
    'isDisabled'
  ],
  data () {
    return {
      isChecked: this.$store.getters.getField(this.id, true, 'content') === '1'
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-radio-default: $color-main
  $color-radio-dark: $color-main-dark
  .checkbox
    display: block
    background-color: $color-radio-default
    color: #fff
    border: 1px solid $color-radio-dark
    cursor: pointer
    height: 100%
    width: 100%
    border-radius: 2px
    box-shadow: inset #000 0px 0px 5px -2px
    input
      display: none
      &:checked + .checkbox__icon
        display: block
    &__icon
      margin: 0
      display: none
      height: 100%
      width: 100%
      padding: 3px
    &.is-disabled
      padding: 0
      background-color: transparent
      border: 0
      box-shadow: none
      color: #333
  // Responsive
  @media screen and (max-width: $screen-size-medium)
    .checkbox
      svg
        padding: 0
</style>
